import { Grid, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { useDispatch } from 'react-redux';

import ButtonComp from 'common/components/Button/ButtonComp';
import {
	setGrammarCheckCompleted,
	setSelectedTask,
	setTabIndex,
} from 'common/store/reducer/mappingDetailsReducer';

import { fiveWValidationResponse } from '../../mappingUtils';

import HighlightedText from './HighLightWords';

import styles from './GrammarCheck.module.scss';

interface IGrammarCheckProps {
	type?: string;
	data: any;
	hideActionButton: boolean;
}

const GrammarCheck = (props: IGrammarCheckProps) => {
	const dispatch = useDispatch();

	const { data, hideActionButton, type } = props;

	const actionClicked = () => {
		dispatch(setTabIndex('tasks'));
		dispatch(setSelectedTask(''));
		dispatch(setGrammarCheckCompleted(true));
	};

	const {
		fiveWValidation,
		availableControlValidation,
		missingControlValidations,
		missingValuesString,
	} = fiveWValidationResponse(data);

	return (
		<Stack className={styles['grammar-check-view-outer-stack']}>
			<Stack direction="row" className={styles['grammar-check-parent-stack']}>
				{fiveWValidation.map((res) => (
					<Stack
						key={res.id}
						direction="row"
						className={styles['grammar-check-child-stack']}
					>
						<Box
							className={styles['validation-block']}
							sx={{ backgroundColor: `${res.color}` }}
						/>
						<Typography className={styles['what-text']}>{res.name}</Typography>
					</Stack>
				))}
				<Grid
					container
					justifyContent={type === 'simulation' ? 'center' : 'flex-end'}
				>
					<Typography className={styles['grammar-score']}>
						Grammar Score:{' '}
						<span className={styles['grammar-score-value']}>
							{data?.grammarScore}
						</span>
					</Typography>
				</Grid>
			</Stack>
			<Typography className={styles['description-text']}>Summary</Typography>
			<Grid
				container
				spacing={2}
				className={
					type === 'simulation'
						? styles['display-flex']
						: styles['display-block']
				}
			>
				<Grid
					item
					xs={12}
					sm={12}
					md={8}
					lg={8}
					xl={8}
					className={styles['textarea-container']}
				>
					<div className={type === 'simulation' ? styles['border-box'] : ''}>
						<HighlightedText
							text={data?.controlDescription || ''}
							wordColors={availableControlValidation}
						/>
					</div>
					{type === 'simulation' && (
						<Grid container justifyContent="end">
							<ButtonComp btnType="primary" compClass={styles['save-button']}>
								save
							</ButtonComp>
						</Grid>
					)}
				</Grid>
				<Grid
					item
					xs={12}
					sm={12}
					md={4}
					lg={4}
					xl={4}
					className={
						type === 'simulation'
							? styles['missingws-div']
							: styles['missingws-alignment']
					}
				>
					<Typography className={styles['missing-ws-text']}>
						Missing Ws
					</Typography>
					<HighlightedText
						text={missingValuesString}
						wordColors={missingControlValidations}
					/>
				</Grid>
			</Grid>
			{!hideActionButton && type !== 'simulation' && (
				<Grid container justifyContent="end">
					<ButtonComp
						btnType="primary"
						compClass={styles['action-button']}
						clickHandler={actionClicked}
					>
						Action/Review
					</ButtonComp>
				</Grid>
			)}
		</Stack>
	);
};

export default GrammarCheck;
